
export default class {
    /**
     * @param {Api} api
     * @param {Function} onLogin
     * @param {Function} onLogout
     */
    constructor(api) {
        this.api = api
        this.onLogin = null
        this.onLogout = null
        this.user = null
        this.API_URL = '/api/admin'
    }

    /**
     * set login handler
     * @param {Function} onLogin 
     */
    setLoginHandler(onLogin) {
        this.onLogin = onLogin
    }

    /**
     * set logout handler
     * @param {Function} onLogout 
     */
    setLogoutHandler(onLogout) {
        this.onLogout = onLogout
    }

    /**
     * Get user
     * @returns {Object<id, email>}
     */
    async getUser() {
        if (this.user) {
            return Promise.resolve(this.user)
        }
        this.user = await this.api.request('GET', this.API_URL, null)
        return this.user
    }

    /**
     * Login user
     * @param {String} username 
     * @param {String} password 
     * 
     */
    async authUser(username, password) {
        if (!username) return Promise.reject('Bad request')
        if (!password) return Promise.reject('Bad request')

        

        const url = `${this.API_URL}/login`
        const body = {
            username: username,
            password: password
        }
        const authUser = await this.api.request('POST', url, body)
        this.user = await this.getUser()
        this.onLogin && await this.onLogin(this.user)
        return authUser
    }

    /**
     * Logout current user
     */
    async logout() {
        const url = `${this.API_URL}/logout`
        this.user = null
        const logout = await this.api.request('GET', url, null)
        this.onLogout && await this.onLogout()
        return logout
    }

    /**
     * Change password of current user
     * @param {String} oldPassword
     * @param {String} newPassword
     */
    async setPassword(oldPassword, newPassword) {
        const url = `${this.API_URL}/set-password`
        const data = { oldPassword, newPassword }
        return await this.api.request('POST', url, data)
    }

    /**
     * Edit profile
     * @param {Object} data
     */
    async updateUserInfo(data) {
        const url = `${this.API_URL}/user/`
        return await this.api.request('PUT', url, data)
    }
}